import React, { Component } from 'react';
import parse from "html-react-parser";

class NotificationTemplate extends Component {
    render() {
      let popupToOpen = this.props.notificationProps.filter(popId => popId.id == this.props.viewPopupId)
      let fromAdmin = popupToOpen[0].fromAdmin
        return (
          <div style={fromAdmin == true ? {whiteSpace: 'pre-wrap'} : {whiteSpace: 'unset'}}>
         { parse(
            popupToOpen[0].notificationMessage
        )}
        </div>
        )
    }
}

export default NotificationTemplate
